import * as React from 'react';

function SvgTickWrong(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 6.03l4.123-4.122a1.393 1.393 0 011.97 1.97L9.97 8l4.122 4.122a1.394 1.394 0 01-1.97 1.97L8 9.97l-4.123 4.122a1.393 1.393 0 01-1.97-1.97L6.03 8 1.908 3.878a1.394 1.394 0 011.97-1.97L8 6.03z"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default SvgTickWrong;
